import React from "react";
import { TableCell } from "@mui/material";
import { ArrowUpward, ArrowDownward, UnfoldMore } from "@mui/icons-material";

const SortIcon = ({ column, sortKey, sortDir }) => {
  if (column !== sortKey) return <UnfoldMore sx={{ fontSize: 14, color: "#94a3b8", ml: 0.25, verticalAlign: "middle" }} />;
  if (sortDir === "asc") return <ArrowUpward sx={{ fontSize: 14, color: "#1976d2", ml: 0.25, verticalAlign: "middle" }} />;
  if (sortDir === "desc") return <ArrowDownward sx={{ fontSize: 14, color: "#1976d2", ml: 0.25, verticalAlign: "middle" }} />;
  return <UnfoldMore sx={{ fontSize: 14, color: "#94a3b8", ml: 0.25, verticalAlign: "middle" }} />;
};

const SortableHeader = ({ label, column, sortKey, sortDir, onSort }) => (
  <TableCell
    onClick={() => onSort(column)}
    sx={{ fontWeight: 700, fontSize: "0.75rem", color: "#64748b", cursor: "pointer", userSelect: "none", "&:hover": { color: "#1976d2" } }}
  >
    {label}
    <SortIcon column={column} sortKey={sortKey} sortDir={sortDir} />
  </TableCell>
);

export default SortableHeader;